<template>
	<div class="shift" :class="fullScalle" :style="shiftColors" @click="handleClick">
		<slot class="single-title" name="unassigned"></slot>
		<slot name="dayOff">
			<span v-if="isDayOff" class="dayOff">DAY OFF</span>
		</slot>

		<div class="shift-inner">
			<slot class="time" name="position"> </slot>

			<slot name="time">
				<span class="time">{{ time }}</span>
			</slot>

			<slot class="single-title" name="title"></slot>

			<div class="employee-info">
				<slot name="image">
					<!--  -->
				</slot>
				<slot name="name">
					<span class="name">{{ employeeFullName }}</span>
				</slot>

				<span v-show="isUnassigned && !isViewOverview" class="unassigned">Unassigned</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'shift',
	props: {
		id: { required: false, type: Number },
		// its gonne be diff in the future
		// default: '10am - 7pm (8h)'
		time: { required: false, type: String },
		// default: 'Kiriakos Vogiatzis'
		employeeFullName: { required: false, type: String },
		employeeImage: { required: false, type: String },
		status: { required: false, type: String },
		dateMoment: { required: false, type: Object },
		position: { required: false, type: String },
		statusColors: { required: false, type: Object },
		isShiftSelected: { required: false, type: Boolean },
		streach: { required: false, type: Boolean, default: false },
		// the view (Overview - Schedule) that this component is called
		view: { required: false, type: String, default: 'Schedule' },
	},
	computed: {
		isViewOverview() {
			return this.view === 'Overview';
		},
		isUnassigned() {
			return this.status === 'unassigned';
		},
		isDayOff() {
			return this.status === 'dayOff';
		},
		shiftColors() {
			return {
				'--textColor': this.isShiftSelected ? '#517fa8' : this.isUnassigned ? '#000' : '#fff',
				'--backgroundColor': this.isShiftSelected ? '#fff' : this.statusColors[this.status],
				// shadow else : 0 0 12px 0 rgba(0, 0, 0, 0.24)
				'--shadow': this.isShiftSelected ? '0 0 19px 0 #79abda' : '',
				'--border': this.isDayOff ? 'solid 1px #757575' : ' solid 1px transparent',
			};
		},
		fullScalle() {
			return this.streach ? 'fullScalle' : '';
		},
	},

	methods: {
		handleClick() {
			this.$emit('shiftClick', this.id, this.position);
			console.log(this.id);
		},
	},
};
</script>

<style lang="scss" scoped>
.shift {
	justify-self: stretch;
	align-self: center;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	min-height: 50px;
	padding: 4px 8px;
	margin: 5px 15px;
	// width: 150px;
	// height: 45px;
	border-radius: 3px;
	background-color: var(--backgroundColor);
	border: var(--border);
	box-shadow: var(--shadow);
	transition: all 0.3s;
	cursor: pointer;

	&.fullScalle {
		width: 100%;
		height: 100%;
	}

	.single-title {
		width: 100%;
		margin-top: 5px;
		font-size: 12px;
		font-weight: bold;
	}
	.dayOff {
		width: 100%;
		margin-top: 5px;
		font-size: 13px;
		font-weight: bold;
		color: #616e84;
	}

	.shift-inner {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		width: 100%;

		.time {
			margin-bottom: 5px;
			font-size: 12px;
			font-weight: bold;
			color: var(--textColor);

			&.normal {
				font-weight: 400;
			}
		}

		.employee-info {
			display: flex;
			flex-direction: row;
			justify-self: flex-start;
			align-items: center;

			.employee-img {
				width: 16px;
				height: 16px;
				object-fit: contain;
				margin-right: 5px;
				border-radius: 50%;
			}

			.name {
				font-size: 11px;
				color: var(--textColor);
			}
			.unassigned {
				color: var(--textColor);
				font-size: 12px;
			}
		}
	}
}
</style>
